import React from "react";
import { Helmet } from "react-helmet-async";
import "./template-creation.scss";
import Alert from "react-bootstrap/Alert";
import CancelModal from "../../../../../components/cancel-modal/cancel-modal";
import TemplateCreateEditConfirmationPanelNew from "../template-panels/template-create-edit-confirmation-panel-new";
import PropTypes from "prop-types";

const TemplateCreationTopNew = ({
  isEdit,
  isView,
  canCreate,
  panelVisibility,
  alertConfig,
  setPanelVisibility,
  setAlertConfig,
  ProjectType,
  templateId,
}) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {isEdit
            ? "TRIYO · " + ProjectType
            : "TRIYO · Create Project Template"}
        </title>
      </Helmet>

      {panelVisibility.showConfirmPanel && (
        <TemplateCreateEditConfirmationPanelNew
          show={panelVisibility.showConfirmPanel}
          templateId={templateId}
          canCreate={canCreate}
          isEdit={isEdit}
          templateName={ProjectType}
        />
      )}

      {panelVisibility.showCancelPanel && (
        <CancelModal
          show={panelVisibility.showCancelPanel}
          onHide={() => {
            setPanelVisibility((prev) => ({ ...prev, showCancelPanel: false }));
          }}
          redirectURL={"/admin?tab=templates"}
        />
      )}

      {alertConfig.showAlert && (
        <Alert
          show={alertConfig.showAlert}
          onClose={() =>
            setAlertConfig({
              showAlert: false,
            })
          }
          variant={alertConfig.alertVariant}
          dismissible
        >
          <Alert.Heading>
            {isEdit
              ? "Unable to Edit Project Template!"
              : "Unable to Create Project Template!"}
          </Alert.Heading>
          <p>{alertConfig.alertMessage}</p>
        </Alert>
      )}

      <h4 className="panel-title">
        {isView
          ? "View Project Template"
          : isEdit
          ? "Edit Project Template"
          : "Create Project Template"}
      </h4>
    </>
  );
};

TemplateCreationTopNew.propTypes = {
  setPanelVisibility: PropTypes.func.isRequired,
  setAlertConfig: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isView: PropTypes.bool.isRequired,
  alertConfig: PropTypes.object.isRequired,
  panelVisibility: PropTypes.object.isRequired,
  ProjectType: PropTypes.string.isRequired,
  templateId: PropTypes.string.isRequired,
  canCreate: PropTypes.bool.isRequired,
};
export default TemplateCreationTopNew;
